import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/payment-review')({
  staticData: {
    title: 'route.orders.paymentReview',
    crumb: 'route.orders.paymentReview',
    permissions: ['orders_payment_review_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
